import { render, staticRenderFns } from "./SectionWhyXid.vue?vue&type=template&id=56c5926c&scoped=true"
import script from "./SectionWhyXid.vue?vue&type=script&lang=ts"
export * from "./SectionWhyXid.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhyXid.vue?vue&type=style&index=0&id=56c5926c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5926c",
  null
  
)

export default component.exports